module.exports = __webpack_public_path__ + "media/customizations/trinityfalls/back-14915f04a7b2c4c06cb8cdc6fc9222bd.jpg";